module.exports = __webpack_public_path__ + "img/1F1E8-1F1EB.99c636e9.svg";